import styled, { css } from "styled-components";
import { FC } from "react";
import { components } from "react-select";

import { styleWrappedComponent } from "./styleWrappedComponent";
import { SelectComponentProps } from "./types";

const StyledMenuList = styled.div`
  ${styleWrappedComponent(css`
    padding: 0;
    border-radius: var(--elevation-2);
  `)};
`;

type MenuListProps = SelectComponentProps["MenuList"];

export const MenuList: FC<MenuListProps> = (props) => (
  <StyledMenuList>
    <components.MenuList {...props}>{props.children}</components.MenuList>
  </StyledMenuList>
);
